export default __webpack_public_path__ + "static/media/Instagram.fadd902e.svg";